import React, { useEffect, useState } from 'react';
import { fetchLogList } from '../../services/logApi'

export default function Dashalim() {
      // 로그 api 위치
      const [logList, setLogList] = useState([]);  
      useEffect(() => {
      const getLogs = async () => {
        try {
          const logs = await fetchLogList();
          setLogList(logs);
        } catch (error) {
          console.error("로그 요청 실패:", error);
          alert("로그 목록을 가져오는 데 실패했습니다.");
        }
      };
  
      getLogs();
    }, []);
    // 로그 api 위치 끝 //
    return (
        <div className="dash_alim dashboard_box">
           <h4>알림</h4>
           <div className="table">
        <table>
          <thead>
            <tr>
              <th scope="col">이름</th>
              <th scope="col">아이디</th>
              <th scope="col">작업내용</th>
              <th scope="col">작업대상</th>
              {/* <th scope="col">IP주소</th> */}
              <th scope="col">일시</th>
            </tr>
          </thead>
          <tbody>
           {logList.length > 0 ? (
              logList.slice(0, 4).map((log, index) => (
              <tr key={index}>
                  <td>{log.admin_name}</td>
                  <td>{log.admin_username}</td>
                  <td>{log.content}</td>
                  <td>{log.username || "-"}</td>
                  {/* <td>{log.ip}</td> */}
                  <td>{log.create_date}</td>
              </tr>
              ))
          ) : (
              <tr>
              <td colSpan="6" style={{ textAlign: 'center' }}>로그가 없습니다.</td>
              </tr>
          )}
          </tbody>
        </table>
      </div>
        </div>
    );
}
